import { render, staticRenderFns } from "./CrmFlashMessage.vue?vue&type=template&id=17744631&scoped=true"
import script from "./CrmFlashMessage.vue?vue&type=script&lang=js"
export * from "./CrmFlashMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17744631",
  null
  
)

export default component.exports